import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'safeYoutube' })
export class SafeYoutubePipe implements PipeTransform {
    private sanitizer: DomSanitizer = inject(DomSanitizer);

    transform(input: string): SafeResourceUrl | null {
        if (!input) return null;

        let url: URL;
        try {
            url = new URL(input);
        } catch {
            return null;
        }

        if (url.username || url.password) {
            return null; // no creds
        }

        const allowed = new Set(['www.youtube.com', 'youtube.com', 'youtu.be', 'm.youtube.com']);
        if (!allowed.has(url.hostname)) {
            return null;
        }

        // Extract video id from common formats
        const id = (url.hostname.includes('youtu.be') && url.pathname.slice(1)) || url.searchParams.get('v') || null;

        if (!id || !/^[a-zA-Z0-9_-]{11}$/.test(id)) {
            return null;
        }

        // Whitelist a few numeric params if you need them
        const safeParams = new URLSearchParams();
        const allowList = ['start', 'end', 'autoplay', 'mute', 'controls'];
        for (const key of allowList) {
            const val = url.searchParams.get(key);
            if (val && /^[0-9]$|^[0-9]{1,6}$/.test(val)) {
                safeParams.set(key, val);
            }
        }

        const embed = `https://www.youtube-nocookie.com/embed/${id}${safeParams.toString() ? `?${safeParams.toString()}` : ''}`;

        return this.sanitizer.bypassSecurityTrustResourceUrl(embed);
    }
}
